import { type TFunction, t as ti18n } from 'i18next'
import type { RecoverableConfiguration, TruckConfiguration } from '#app/store/slices/configurationSlice'
import { extractTitle } from '#features/Configuration/ConfigurationTitle'

export function makeCopyOfConfigurationTitle(configuration: TruckConfiguration, tFunc?: TFunction) {
  const { configurationTitle, defaultConfigurationTitle } = extractConfigurationTitle(configuration)

  if (configurationTitle === defaultConfigurationTitle) {
    return defaultConfigurationTitle
  }
  const t = tFunc ?? ti18n

  let copyCount = 1
  let baseConfigurationTitle = configurationTitle

  const titleMarker = '__XXX__'
  const numberInConfigurationTitle = configurationTitle.match(/[\s|#](\d+)\s/)
  if (numberInConfigurationTitle) {
    const number = parseInt(numberInConfigurationTitle[1], 10)
    if (!Number.isNaN(number)) {
      copyCount = number + 1

      const sampleCopyWithCount = t('configuration.title.copy-of-prefix', 'Copy of {{title}}', { title: titleMarker, count: number })
      const indexOfTitle = sampleCopyWithCount.indexOf(titleMarker)
      if (indexOfTitle !== -1 && indexOfTitle < configurationTitle.length) {
        baseConfigurationTitle = configurationTitle.substring(indexOfTitle)
      }
    }
  } else {
    const sampleCopyWithoutCount = t('configuration.title.copy-of-prefix', 'Copy of {{title}}', { title: titleMarker, count: 1 })
    const indexOfTitle = sampleCopyWithoutCount.indexOf(titleMarker)
    if (indexOfTitle !== -1 && indexOfTitle < configurationTitle.length) {
      copyCount = 2
      baseConfigurationTitle = configurationTitle.substring(indexOfTitle)
    }
  }

  return t('configuration.title.copy-of-prefix', 'Copy of {{title}}', { title: baseConfigurationTitle, count: copyCount })
}

export function extractConfigurationTitle(configuration: TruckConfiguration | RecoverableConfiguration | undefined) {
  const configurationTitle = configuration && 'title' in configuration ? configuration.title : undefined
  return extractTitle(configurationTitle)
}
